/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function CalendarEventIcon(props) {
  return (
    <svg {...props} viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.83301 1.66699H10V0H11.5V1.66699H12.417C13.0578 1.66709 13.6728 1.9209 14.126 2.37402C14.5791 2.82716 14.8329 3.44219 14.833 4.08301V14.083C14.833 14.7238 14.579 15.3388 14.126 15.792C13.6728 16.2451 13.0578 16.4999 12.417 16.5H2.41699C1.77606 16.5 1.16122 16.2452 0.708008 15.792C0.254795 15.3388 0 14.7239 0 14.083V4.08301C8.6173e-05 3.44219 0.254872 2.82716 0.708008 2.37402C1.16119 1.92102 1.77621 1.66699 2.41699 1.66699H3.33301V0H4.83301V1.66699ZM1.5 14.083C1.5 14.3261 1.59665 14.5595 1.76855 14.7314C1.94046 14.9033 2.17389 15 2.41699 15H12.417C12.6599 14.9999 12.8926 14.9032 13.0645 14.7314C13.2364 14.5595 13.333 14.3261 13.333 14.083V8.16699H1.5V14.083ZM7.41699 10C7.83104 10.0002 8.16699 10.3359 8.16699 10.75V14H6.66699V11.5H5.83301V10H7.41699ZM2.41699 3.16699C2.17389 3.16699 1.94046 3.26365 1.76855 3.43555C1.59682 3.60736 1.50009 3.84009 1.5 4.08301V6.66699H13.333V4.08301C13.3329 3.84002 13.2363 3.60738 13.0645 3.43555C12.8926 3.26372 12.66 3.16709 12.417 3.16699H11.5V4.83301H10V3.16699H4.83301V4.83301H3.33301V3.16699H2.41699Z"
        fill="currentColor"
      />
    </svg>
  )
}

CalendarEventIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default CalendarEventIcon
